import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { CheckoutState } from '../types/checkout';

export const useCheckoutStore = create<CheckoutState>()(
  devtools(
    set => ({
      checkoutSessionData: null,
      checkoutEventData: null,
      sdkSessionActive: false,
      isSdkCheckoutEnabled: false,
      iframeCheckoutActive: false,
      recurrenceOptinStatus: null,
      recurrenceSessionData: null,

      setCheckoutSessionData: checkoutSessionData =>
        set({ checkoutSessionData }, false, 'setCheckoutSessionData'),
      setCheckoutEventData: checkoutEventData =>
        set({ checkoutEventData }, false, 'setCheckoutEventData'),
      setSdkSessionActive: sdkSessionActive =>
        set({ sdkSessionActive }, false, 'setSdkSessionActive'),
      setIsSdkCheckoutEnabled: isSdkCheckoutEnabled =>
        set({ isSdkCheckoutEnabled }, false, 'setIsSdkCheckoutEnabled'),
      setIframeCheckoutActive: iframeCheckoutActive =>
        set({ iframeCheckoutActive }, false, 'setIframeCheckoutActive'),
      setRecurrenceOptinStatus: recurrenceOptinStatus =>
        set({ recurrenceOptinStatus }, false, 'setRecurrenceOptinStatus'),
      setRecurrenceSessionData: recurrenceSessionData =>
        set({ recurrenceSessionData }, false, 'setRecurrenceSessionData'),
      clearCheckout: () =>
        set(
          {
            checkoutSessionData: null,
            checkoutEventData: null,
            sdkSessionActive: false,
            isSdkCheckoutEnabled: false,
            iframeCheckoutActive: false,
            recurrenceOptinStatus: null,
            recurrenceSessionData: null,
          },
          false,
          'clearCheckout',
        ),
    }),
    { name: 'CheckoutStore' },
  ),
);
